// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CompletedIdeasWrapper_wrapper__2mEbq","btn":"CompletedIdeasWrapper_btn__3aV4I","page":"CompletedIdeasWrapper_page__S_P39"};